var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#222222",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 19.7143C15.3118 19.7143 15.7478 19.5337 16.0693 19.2122C16.3908 18.8907 16.5714 18.4547 16.5714 18C16.5714 17.5453 16.3908 17.1093 16.0693 16.7878C15.7478 16.4663 15.3118 16.2857 14.8571 16.2857C14.4025 16.2857 13.9665 16.4663 13.645 16.7878C13.3235 17.1093 13.1429 17.5453 13.1429 18C13.1429 18.4547 13.3235 18.8907 13.645 19.2122C13.9665 19.5337 14.4025 19.7143 14.8571 19.7143ZM20 12C20.4547 12 20.8907 12.1806 21.2122 12.5021C21.5337 12.8236 21.7143 13.2596 21.7143 13.7143V22.2857C21.7143 22.7404 21.5337 23.1764 21.2122 23.4979C20.8907 23.8194 20.4547 24 20 24H9.71429C9.25963 24 8.82359 23.8194 8.5021 23.4979C8.18061 23.1764 8 22.7404 8 22.2857V13.7143C8 13.2596 8.18061 12.8236 8.5021 12.5021C8.82359 12.1806 9.25963 12 9.71429 12H10.5714V10.2857C10.5714 9.14907 11.023 8.05898 11.8267 7.25526C12.6304 6.45153 13.7205 6 14.8571 6C15.42 6 15.9772 6.11085 16.4972 6.32623C17.0172 6.54161 17.4896 6.85729 17.8876 7.25526C18.2856 7.65322 18.6012 8.12568 18.8166 8.64564C19.032 9.16561 19.1429 9.72291 19.1429 10.2857V12H20ZM14.8571 7.71429C14.1752 7.71429 13.5211 7.9852 13.0389 8.46744C12.5566 8.94968 12.2857 9.60373 12.2857 10.2857V12H17.4286V10.2857C17.4286 9.60373 17.1577 8.94968 16.6754 8.46744C16.1932 7.9852 15.5391 7.71429 14.8571 7.71429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.d63c1a11101bd1a97a39249fdac35ad9.svg";
export { ForwardRef as ReactComponent };